// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card_service[data-v-0c202b0c]{box-shadow:5px 5px 5px #bebebe;border:1px solid #bebebe;margin-bottom:20px;padding:20px;border-radius:5px}", ""]);
// Exports
module.exports = exports;
